import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import AnnualForecastTotalData from "./AnnualForecastTotalData";

const AnnualForecastTotal = ({ 
    forecastName,
    forecastVersion,
} : {
    forecastName?: string,
    forecastVersion?: number
}) => {    
    // Récupération globale des totaux
    const rawTotals = useSelector((state: RootState) => state.forecast.totals);

    const totalBySection = useMemo(() => {
        const t: any = rawTotals || {};

        return {
            "CA - Régie": t["Régie"] || {},
            "CA - Forfait": t["Forfait"] || {},
            "CA - Hébergement": t["Hébergement"] || {},
            "CA - TMA/TME": t["TMA/TME"] || {},
            "CA - TRA": t["TRA"] || {},
            "Salariés": t["Salariés"] || {},
            "Epargne": t["Epargne"] || {},
            "TNS": t["TNS"] || {},
            "Frais de fonctionnement": t["Frais de fonctionnement"] || {},
            "Investissements": t["Investissements"] || {},
            "Entreprise": t["Entreprise"] || {},
            // Fusion sécurisée de la sous-traitance
            "Sous-traitance": (t["Sous-traitance-Forfait"] && t["Sous-traitance-Régie"]) 
                ? Object.keys(t["Sous-traitance-Forfait"]).reduce((acc: any, key) => {
                    acc[key] = (Number(t["Sous-traitance-Forfait"][key]) || 0) + 
                               (Number(t["Sous-traitance-Régie"][key]) || 0);
                    return acc;
                }, {})
                : (t["Sous-traitance-Forfait"] || t["Sous-traitance-Régie"] || {}),
            "DGFIP": t["DGFIP"] || {},
        };
    }, [rawTotals]);

    return (
        <AnnualForecastTotalData 
            forecastVersion={forecastVersion} 
            forecast={forecastName} 
            totalBySection={totalBySection} 
        />
    );
}

export default AnnualForecastTotal;